import { type NotificationType } from '@/redux/slices/notificationSlice'
import ItemWrapper from './ItemWrapper'

export default function TradeOrderExport({ notification }: { notification: NotificationType }) {
  const { startDate, endDate } = notification.activity as { startDate?: string | null; endDate?: string | null }
  const range = startDate && endDate ? `${startDate} ~ ${endDate} ` : ''

  return <ItemWrapper notification={notification}>{range}交易记录 数据导出成功</ItemWrapper>
}
